import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgScorpio = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.33337 10.9649V10.6666C3.33337 8.82564 4.82576 7.33325 6.66671 7.33325C8.50766 7.33325 10 8.82564 10 10.6666V25.9999M10 10.9649C10 8.95921 11.626 7.33325 13.6317 7.33325H14C16.2092 7.33325 18 9.12411 18 11.3333V25.9999M18 10.9327C18 8.9448 19.6116 7.33325 21.5995 7.33325H22C24.2092 7.33325 26 9.12411 26 11.3333V23.1917C26 24.7426 27.2573 25.9999 28.8083 25.9999H31.3334M30 23.3333L32.6667 25.9999L30 28.6666",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgScorpio;
